export default "/_next/static/images/ServiceSittingCircleIcon-4fd789e5b3fa2545b20a0efff49d08da.svg";